import React from "react";

function HomeIconSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 28 28"
      className={props.className}
    >
      <circle
        cx="14"
        cy="14"
        r="14"
        fill={props?.bgfill ? props?.bgfill : "#FFFFFF"}
      ></circle>
      <path
        fill="#FF752C"
        d="M19.625 11.5a.375.375 0 10-.75 0h.75zm-10.5 0a.375.375 0 10-.75 0h.75zm11.36 1.766a.375.375 0 00.531-.53l-.531.53zm-6.484-7.015l.265-.266a.375.375 0 00-.531 0l.266.266zm-7.016 6.484a.375.375 0 10.531.531l-.531-.53zm3.266 7.39h7.5v-.75h-7.5v.75zm9.374-1.874V11.5h-.75v6.75h.75zm-10.5 0V11.5h-.75v6.75h.75zm11.891-5.516l-6.75-6.75-.531.531 6.75 6.75.531-.53zm-7.281-6.75l-6.75 6.75.531.531 6.75-6.75-.531-.53zm4.015 14.14a1.875 1.875 0 001.875-1.874h-.75a1.125 1.125 0 01-1.125 1.125v.75zm-7.5-.75a1.125 1.125 0 01-1.125-1.124h-.75a1.875 1.875 0 001.876 1.875v-.75z"
      ></path>
    </svg>
  );
}

export default HomeIconSvg;
